import { Form, Input, InputNumber, Switch } from "antd";
import { useTranslation } from "react-i18next";
import useCoreStore from "views/hooks/useCoreStore";

interface EditableCellProps {
  editing: boolean;
  dataIndex: string;
  inputType: "boolean" | "number" | "text";
  children: React.ReactNode;
  record: ListCurrenciesPaginatedData;
  [key: string]: unknown;
}

export default function EditableCell({
  editing,
  dataIndex,
  inputType,
  children,
  record,
  ...restProps
}: EditableCellProps): React.ReactElement {
  const { t } = useTranslation();
  const companySettings = useCoreStore(state => state.companySettings);
  const cantChange = companySettings?.hasCurrencyWithValidatedDocuments;

  const isMainCurrency = record?.isMainCurrency;

  const disable = cantChange ? isMainCurrency || dataIndex !== "isActive" : false;

  let inputNode;
  let valuePropName = "value";

  if (inputType === "boolean") {
    inputNode = <Switch disabled={disable} />;
    valuePropName = "checked";
  } else if (inputType === "number") {
    inputNode = <InputNumber disabled={disable} />;
  } else if (inputType === "text") {
    inputNode = <Input disabled={disable} />;
  }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          valuePropName={valuePropName}
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[{ required: true, message: t("This field is required") }]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
}
